import register from '../../../../global/js/registry';
export default register('o-product-list', () => import(/* webpackMode: "lazy" */ './o-product-list.controller'));
